import React, { useContext, useMemo, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { InfluencerContext } from '../../../../contexts/InfluencerContext'
import { SharedCampaignContext } from '../../../../contexts/Advertiser/SharedCampaignContext'
import { SharedInfluencerContext } from '../../../../contexts/Advertiser/SharedInfluencerContext'
import Authentication from '../../../../models/Authentication'
import { observer } from 'mobx-react-lite'
import Post from '../../Shared/Post'
import axiosService from '../../../../utils/AxiosService'
import { toastError } from '../../../../components/FormComponents/Toasts'

export default observer(function SocialPosts() {
  const params = useParams()
  const { id, authentication_id, campaign_authentication_id } = params
  const influencerContext = useContext(InfluencerContext)
  const sharedCampaignContext = useContext(SharedCampaignContext)
  const sharedInfluencerContext = useContext(SharedInfluencerContext)
  const [authentications, setAuthentications] = useState([])

  const isAdvertiserContext = !!sharedCampaignContext?.campaignState
  const isInfluencerShareContext = !!sharedInfluencerContext?.influencerState
  const currentId = isInfluencerShareContext
    ? (sharedInfluencerContext?.authentications?.[0]?.id)
    : (isAdvertiserContext ? authentication_id : id)

  useEffect(() => {
    if (isAdvertiserContext && authentication_id) {
      axiosService.get(`/api/advertiser/campaign_share/authentications/${authentication_id}/authentications`)
        .then(authentications => {
          const mappedAuthentications = authentications.map(authentication => new Authentication(authentication))
          setAuthentications(mappedAuthentications)
        })
        .catch((error) => {
          const errorMessage = error?.response?.data?.error || error?.data?.error || error?.error || error?.message || 'An error occurred'
          toastError(errorMessage)
        })
    }
  }, [isAdvertiserContext, authentication_id])

  const pmAuthentications = influencerContext?.authentications || []
  const sharedInfluencerAuthentications = sharedInfluencerContext?.authentications || []
  const currentAuthentications = isInfluencerShareContext
    ? sharedInfluencerAuthentications
    : (isAdvertiserContext ? authentications : pmAuthentications)

  const currentAuthentication = useMemo(() => currentAuthentications.find(authentication => +authentication.id === +currentId ) || new Authentication(), [currentId, currentAuthentications, currentAuthentications.length] )
  const posts = useMemo(() => currentAuthentication.posts || [], [currentAuthentication.posts, currentAuthentication.posts?.length])

  return (
    <div>
      <div className="flex flex-wrap gap-4">
        {posts.map(post => (
          <Post key={post.id} post={post} reach={currentAuthentication.reach} />
        ))}
      </div>
    </div>
  )
})